<template>
  <div class="text-center">
    <div>
      <h3><i class="fa fa-cloud-upload " aria-hidden="true"></i> Upload Product Image:</h3>
      <input type="file" @change="previewImage" class="btn btn-primary" accept="image/*" required />
    </div>
    <br />
    <div>
      <p>
        Progress: {{ uploadValue.toFixed() + "%" }}
        <progress id="progress" :value="uploadValue" max="100"></progress>
      </p>
    </div>
    <div v-if="imageData != null">
      <img class="preview" :src="picture" />
      <br />
      <br />
      <button class="btn btn-primary text-center" type="button" @click="onUpload">
        Upload
      </button>
    </div>
  </div>
</template>
<script>
import { storage } from "../db";
import picStore from "../helpers/imageStore.js";
export default {
  name: "Upload",
  data() {
    return {
      imageData: null,
      picture: null,
      uploadValue: 0
    };
  },
  methods: {
    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
    },

    onUpload() {
      this.picture = null;
      var uid = this.$store.getters.getUser.uid;
      picStore.picture = uid + "/" + this.imageData.name;
      const storageRef = storage
        .ref("med_img/" + uid)
        .child(this.imageData.name)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        snapshot => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        error => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then(url => {
            this.picture = url;
            picStore.picture = this.picture;
          });
        }
      );
    }
  }
};
</script>
<style scoped>
img.preview {
  width: 200px;
}
progress {
  background-color: #f3f3f3;
  border: 0;
  height: 18px;
  border-radius: 9px;
}
progress::-webkit-progress-value {
  background-image:
	   -webkit-linear-gradient(-45deg, 
	                           transparent 33%, rgba(0, 0, 0, .1) 33%, 
	                           rgba(0,0, 0, .1) 66%, transparent 66%),
	   -webkit-linear-gradient(top, 
	                           rgba(255, 255, 255, .25), 
	                           rgba(0, 0, 0, .25)),
	   -webkit-linear-gradient(left, #09c, #f44);

    border-radius: 2px; 
    background-size: 35px 20px, 100% 100%, 100% 100%;
}
@-webkit-keyframes animate-stripes {
   100% { background-position: -100px 0px; }
}

@keyframes animate-stripes {
   100% { background-position: -100px 0px; }
}

-webkit-animation: animate-stripes 5s linear infinite;
        animation: animate-stripes 5s linear infinite;
</style>
